const nameRegEx = /[^0-9_;:*@#!()?¤$=£§%&/"]+/g;
const parseName = (input: string) => (input.match(nameRegEx) || []).join('');

export const formatName = (input: string) => {
    if (nameRegEx.test(input) && input !== '') {
        return parseName(input);
    }
    return '';
};
